<template>
  <div class="kb-chart-card d-flex justify-center">
    <vue-funnel-graph :width="width" :height="height" :labels="labels"
                      :values="values" :colors="colors" :direction="direction"
                      :gradient-direction="gradientDirection"
                      :animated="true" :display-percentage="true" />
  </div>
</template>

<script>
import { VueFunnelGraph } from 'vue-funnel-graph-js'
export default {
  components: { VueFunnelGraph },
  created () {
    this.setChartValues()
  },
  data () {
    return {
      labels: [this.$tc('general.sent', 2), this.$tc('general.opened', 1), 'Clicked'],
      values: [3, 2, 1],
      colors: ['#FFB178', '#A0BBFF', '#A0F9FF'],
      direction: 'vertical',
      gradientDirection: 'vertical',
      height: 300,
      width: 1000
    }
  },
  methods: {
    setChartValues () {
      const {
        totalSent,
        totalOpened,
        totalClicked
      } = this.campaign
      const efectiveInfo = [
        { key: this.$tc('general.sent', 2), value: totalSent },
        { key: this.$tc('general.opened', 1), value: totalOpened },
        { key: 'Clicked', value: totalClicked }
      ]
      efectiveInfo.sort((a, b) => b - a)
      this.labels = efectiveInfo.map(item => item.key)
      this.values = efectiveInfo.map(item => item.value)
    }
  },
  props: {
    campaign: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style>
[data-v-52d787cd].label__value {
  color: #172B4D!important;
}
</style>
